import { render, staticRenderFns } from "./OrganizerDealers.vue?vue&type=template&id=53d3dfbb&"
import script from "./OrganizerDealers.vue?vue&type=script&lang=js&"
export * from "./OrganizerDealers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports